// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-excel-container {
    padding: 20px;
    background-color: #f8f8f8;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .date-picker-container {
    display: flex;
    gap: 10px;
  }
  
  .date-picker {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
  }
  
  .label {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 5px;
  }
  
  .input {
    width: 150px;
    padding: 8px;
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid #d1d5db;
    background-color: white;
    outline: none;
  }
  
  .error-message {
    color: #ef4444;
    font-size: 14px;
    margin-bottom: 10px;
  }
  
  .download-btn {
    background-color: var(--primary-color);
    color: white;
    font-weight: bold;
    padding: 12px 20px;
    border-radius: 5px;
    cursor: pointer;
    border: none;
    transition: background-color 0.3s;
    margin-top: 15px;
  }
  
  .download-btn:hover {
    background-color: var(--primary-color);
  }
  
  .download-btn:disabled {
    background-color: #d1d5db;
    cursor: not-allowed;
  }
  
  .modal-content {
    max-height: 80vh;
    overflow-y: auto;
  }
  
  .modal-message {
    font-size: 14px;
    margin-bottom: 12px;
  }
  
  .password-input-container {
    position: relative;
  }
  
  .password-input {
    width: 95%;
    padding: 10px;
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid #d1d5db;
    background-color: white;
  }
  
  .password-visibility-toggle {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #6b7280;
    font-size: 14px;
    cursor: pointer;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/download-excel/download-excel.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;EACjB","sourcesContent":[".download-excel-container {\n    padding: 20px;\n    background-color: #f8f8f8;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  .date-picker-container {\n    display: flex;\n    gap: 10px;\n  }\n  \n  .date-picker {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 15px;\n  }\n  \n  .label {\n    font-size: 14px;\n    color: #6b7280;\n    margin-bottom: 5px;\n  }\n  \n  .input {\n    width: 150px;\n    padding: 8px;\n    font-size: 14px;\n    border-radius: 4px;\n    border: 1px solid #d1d5db;\n    background-color: white;\n    outline: none;\n  }\n  \n  .error-message {\n    color: #ef4444;\n    font-size: 14px;\n    margin-bottom: 10px;\n  }\n  \n  .download-btn {\n    background-color: var(--primary-color);\n    color: white;\n    font-weight: bold;\n    padding: 12px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    border: none;\n    transition: background-color 0.3s;\n    margin-top: 15px;\n  }\n  \n  .download-btn:hover {\n    background-color: var(--primary-color);\n  }\n  \n  .download-btn:disabled {\n    background-color: #d1d5db;\n    cursor: not-allowed;\n  }\n  \n  .modal-content {\n    max-height: 80vh;\n    overflow-y: auto;\n  }\n  \n  .modal-message {\n    font-size: 14px;\n    margin-bottom: 12px;\n  }\n  \n  .password-input-container {\n    position: relative;\n  }\n  \n  .password-input {\n    width: 95%;\n    padding: 10px;\n    font-size: 14px;\n    border-radius: 4px;\n    border: 1px solid #d1d5db;\n    background-color: white;\n  }\n  \n  .password-visibility-toggle {\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    color: #6b7280;\n    font-size: 14px;\n    cursor: pointer;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
